<template>
  <b-modal id="modal-confirm-cancel" header-class="danger">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div> 
          <h5>{{ $t('engine.manageAppearance.theme.font.manageFont.modalCancel.lblTitle', languageEngine) }}</h5>
        </div>
        <div class="d-flex">
          <div class="mr-gd-1">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            id="close-modal-confirm-cancel"
            class="close-modal cursor-pointer"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div>
        {{ $t('engine.common.modal.upload.lblText', languageEngine) }}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="danger" @click="confirm"> {{ $t('engine.common.modal.upload.cancel', languageEngine) }} </b-button>
      <b-button variant="light" @click="closeModal" class="mr-3">  {{ $t('engine.common.modal.upload.continue', languageEngine) }} </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-cancel");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-cancel");
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  }
}
</script>